/**
 * ACTIVITY-CORE API client for fetching older activity history pages.
 */
import { type ActivityHistoryPage, mapApiActivityRow } from "@fleet/plugins/activity";

interface ActivityApiResponse {
  items: Parameters<typeof mapApiActivityRow>[0][];
  next_before: string | null;
}

export async function fetchOlderActivity(
  before: string | null,
  limit: number,
  filter?: Record<string, unknown>,
): Promise<ActivityHistoryPage | null> {
  try {
    const params = new URLSearchParams();
    if (before) {
      params.set("before", before);
    }
    params.set("limit", String(limit));
    if (filter?.entityType) {
      params.set("entity_type", String(filter.entityType));
    }
    if (filter?.entityId) {
      params.set("entity_id", String(filter.entityId));
    }

    const res = await fetch(`/api/activity?${params.toString()}`, {
      headers: {
        Accept: "application/json",
      },
    });

    if (!res.ok) {
      return null;
    }

    // oxlint-disable-next-line typescript/no-unsafe-type-assertion
    const data = (await res.json()) as Partial<ActivityApiResponse>;
    const rows = (data.items ?? []).map((row) => mapApiActivityRow(row));
    return {
      rows,
      hasMore: Boolean(data.next_before),
    };
  } catch {
    return null;
  }
}
